import pkg from '../../package.json';
export const environment = {
  version: pkg.version,
  production: false,
  envName: 'staging',
  host: "test-staging.litmusworld.com",
  base_url: "https://test-staging.litmusworld.com/rateus/",
  isDocker: false,
  urlPath: "/v3/",
  /**
   * Sentiment Analysis — insights engine behind staging host path `/sentiment_analysis`.
   * Microservice must set API_BASE_PATH=/sentiment_analysis (see micro-service `staging.env`).
   */
  sentimentAnalysis: {
    apiBaseUrl: 'https://staging.litmusworld.com/sentiment_analysis',
    useInsightsEngine: true,
    insightsStatsPathPrefix: '/api/stats/v1',
    insightsSummaryRunPath: '/api/summary/v2/run',
    insightsForwardUserName: true,
    statsTimeField: 'created_date',
    statsTimezone: 'Asia/Kolkata',
  },
  is_lw3_permitted_account: false,
  ssoAutoRedirectTime: 1000,
  google_analytics: {
    property_id: "UA-65876274-22",
    clicks_monitor_id: "GTM-TZRGDFR"
  },
  google_analytics_4: {
    measurement_id: "G-E3LQWZW3QZ"
  },
  google_recaptcha: {
    sitekey: "6Ldi1QkTAAAAACzb2TlhhLfj87_DJn9DBWb97TMF",
    theme: "light"
  },
  google_recaptcha_v3: {
    sitekey: "6LeoxHUqAAAAAMIlNpGlFu43W0F9O_JCtm3rbLjh",
    theme: "light"
  },
  support: {
    request_api_url: "https://localhost:5021/rateus/api/feedbackrequests/generate_customer_feedback_url",
    app_id: "z1vv_default"
  },
  litmus: {
    feedback_app_id: "no92_dd021",
    gtm_id: "GTM-MHXJHHD",
    bugs_gtm_id: "GTM-W3JMBVS",
    login_banner_1_url: "https://localhost:5021/rateus/preview-v2/5bb20cfe542b8c2007e7ea2f",
    login_banner_2_url: "https://localhost:5021/rateus/preview-v2/5bb44a270973dd5175d6568e",
    contact_us: {
      app_id: "0mhz_contactus",
      request_api_url: "https://localhost:5021/rateus/api/feedbackrequests/generate_customer_feedback_url",
      target_server: "Staging"
    },
    pass_reset_limit: 10
  },
  csp: {
    enforce_csp: true,
    csp_policy: "default-src 'self'; script-src 'self' 'nonce-{{NONCE}}' 'strict-dynamic' cdnjs.cloudflare.com cdn.jsdelivr.net *.googleapis.com *.google-analytics.com *.litmusworld.com *.googletagmanager.com *.google.com *.gstatic.com *.cloudfront.net www.recaptcha.net; style-src 'self' 'nonce-{{NONCE}}' *.litmusworld.com use.fontawesome.com cdnjs.cloudflare.com cdn.jsdelivr.net fonts.googleapis.com maxcdn.bootstrapcdn.com; style-src-attr 'unsafe-inline'; img-src 'self' data: blob: googletagmanager.com *.googletagmanager.com *.litmusworld.com *.google-analytics.com maps.gstatic.com *.gstatic.com *.google.com litmusworld-feedback-photos.s3.amazonaws.com via.placeholder.com; font-src 'self' data: maxcdn.bootstrapcdn.com use.fontawesome.com fonts.gstatic.com *.gstatic.com *.litmusworld.com cdnjs.cloudflare.com cdn.jsdelivr.net; connect-src 'self' blob: cdn.jsdelivr.net cdnjs.cloudflare.com http://localhost:* https://localhost:* http://127.0.0.1:* https://127.0.0.1:* ws: wss: *.litmusworld.com lwcx.in s.lwcx.in *.lwcx.in *.google-analytics.com *.googleapis.com *.gstatic.com *.google.com *.firebaseio.com *.firebase.com *.firebaseapp.com www.recaptcha.net *.cloudfront.net *.amazonaws.com *.sbilife.co.in *.kotak.int *.axisb.com *.indusind.com *.bajajallianzlife.com *.equitasbank.com *.ltms.io *.cesc.co.in *.cosmosbank.com *.koltepatil.com *.hbctxdom.com *.havells.com *.axisbank.com *.rbl.bank.in fb.rbl.bank.in *.prod.kotak.int feedback.prod.kotak.int *.hdfc.int *.prod.hdfc.int feedback.prod.hdfc.int *.hdfcbankuat.com http://10.9.12.169:* http://10.3.4.105:* http://172.17.138.75:*; frame-src 'self' blob: youtube.com www.youtube.com youtube-nocookie.com www.youtube-nocookie.com *.google.com *.litmusworld.com lwcx.in s.lwcx.in *.lwcx.in www.recaptcha.net http://localhost:* https://localhost:* http://127.0.0.1:* https://127.0.0.1:*; frame-ancestors 'self'; object-src 'self'; base-uri 'self'; form-action 'self' http://localhost:* https://localhost:* *.litmusworld.com lwcx.in s.lwcx.in *.lwcx.in *.google.com; media-src 'self' blob: data: *.litmusworld.com; worker-src 'self' blob:",
    report_mode: false,
    report_uri: "; report-uri http://localhost:5021/rateus/api/webhooks/csp_mailer"
  },
  tutorial_videos: {
    tvsmotor: {
      login_video_url: "https://tvshosur-my.sharepoint.com/:f:/g/personal/customercare_tvsmotor_com/Empb4o2s6qFJkKh04gS5wksB9vFwSyPOrzOMZoFwMWuGHw?e=luK8mC",
      login_video_display_text: "Training videos"
    }
  },
  secureSessionStorage: {
    key: 's$=a!.6HMB41!60_U0gm3ygNq-wp8@ZC',
    enable: true
  },
  fireBase: {
    vapidKey: "BIov3wzrbUqHbE2o3Mt0f95VOEZj7G1dQf29RSdR24NATtnEZbyD_YIMG7pT4CgDM6MmSMvtcEsothUrIGrX4g8",
    firebaseConfig: {
      apiKey: "AIzaSyBJK04K3PTFuzhnCk9om1R09Yp4fnLs32E",
      authDomain: "litmusworld-pulse.firebaseapp.com",
      databaseURL: "https://litmusworld-pulse.firebaseio.com",
      projectId: "litmusworld-pulse",
      storageBucket: "litmusworld-pulse.appspot.com",
      messagingSenderId: "1052142720091",
      appId: "1:1052142720091:web:7ccd0dcae683f529"
    }
  },
  webPrivateV1: {
    protocol: 'https',
    port: '443',
    apiPrefix: '/rateus/api',
    brandsDataById: '/brands/by_id',
    brandsDataByList: '/brands/list',
    brandsStatusList: '/brands/status_list',
    brandsStatusListV2: '/brands/status_list_v2',
    brandsByIdList: '/brands/by_id_list',
    accountDataById: '/accounts/by_id',
    accountDataByManagerIdV2: '/accounts/details_by_manager_id_v2',
    feedbackRequestByAdhocEventId: '/feedbackrequests/by_adhoc_event_id',
    onDemandDispatch: '/notification_services/on_demand_dispatch',
    customerNotifierConfiguration: '/brands/customer_notifier_configuration',
    feedList: '/feeds/list',
    feedListV3: '/feeds/list_v3',
    feedDetailsV4: '/feeds/by_id_v4',
    huddleSummaryActive: '/huddle_summary/active_tasks',
    feedDetailsHistory: '/feeds/event_logs',
    validateEmail: '/managers/validate_user_name_v2',
    validateUserPassword: '/validate_user_password',
    forget_password: '/forgot_password',
    reset_password: '/reset_password',
    me: '/me',
    logout: '/logout',
    updateLogoutTime: '/managers/update_logout_time',
    resendOtp: '/managers/resend_otp',
    validate_password: '/managers/validate_password',
    webPushNotificationSubscription: "/managers/save_device_token",
    unSubscribeWebPushNotification: "/managers/update_device_token",
    changeNewPassword: '/users/change_password',
    getHierarchyLevel: '/hierarchies/custom_search',
    getVerbatimFeeds: '/feeds/list',
    updateBrandsConfiguration: '/settings',
    dashboardConfiguration: '/configs/dashboard_configuration',
    updateAccountsConfiguration: '/accounts/update',
    accountManagersByAccountId: '/accounts/managers',
    createAccount: '/accounts/create',
    comment: '/comment',
    multimediaFilesUpload: "/uploaders/multimedia_file_upload",
    setManagerDefaultAccess: '/managers/set_default_access',
    getDetailComponentList: '/actions/issue_detail_components_list',
    createDownloadJob: '/jobs/create',
    setCurrentLoggedInManager: '/managers/current_loggedin_manager',
    searchPossibleValues: '/search/filters_possible_values?',
    searchManagers: '/managers/search_v2',
    searchRoleBased: '/managers/role_based_search',
    categoryList: '/categories/list_v2',
    creteCategory: '/categories/create',
    updateCategory: '/categories/update',
    removeCategory: '/categories/remove',
    updateBrandConfiguration: '/configs/dashboard_configuration',
    updateFieldDefinitions: '/brands/field_definitions',
    getFieldDefinitions: '/brands/field_definitions',
    getUiRuleStatus: '/actions/ui_rule_validation',
    fileUrl: '/contents/file?file_id=',
    AFPConfigUrl: '/configs/afp_configs',
    infraFileUpload: '/infra/upload',
    infraJobStatus: '/infra/status',
    infraFileUrl: '/infra/url',
    hierarhchyFileUpload: '/uploaders/dynamic_hierarchy_file_upload',
    createNote: '/notes/create',
    updateCustomParameter: '/feeds/assign',
    feedEvent: "/events/feed",
    searchFeed: '/search/feeds',
    searchUser: '/search/users_new',
    workFlowRules: '/actions/workflow_rules',
    workFlowRule: '/actions/workflow_rule',
    workFlowList: '/actions/workflow_list',
    authKey: '/ts/auth_key',
    getManagerConfig: '/manager_configurations/get_config',
    saveManagerConfig: '/manager_configurations/save_config',
    infraFileDownload: '/infra/file?id=',
    adrStatus: '/feedbacks/advanced_download_request_status',
    comments: '/text_analytics/comments',
    getNGrams: '/text_analytics/n_grams',
    linkedWords: '/text_analytics/linked_words',
    keywordsTrends: '/text_analytics/keyword_trends',
    noiseAndInterestWords: '/text_analytics/other_words',
    noiseWordList: '/text_analytics/noise_word',
    interestWordList: '/text_analytics/interest_word',
    getText: '/text_analytics_v2/main',
    compareTags: '/text_analytics_v2/compare',
    commentsV2: '/text_analytics_v2/comments',
    moduleConfigs: '/configs/module_config_v2',
    afpConfings: '/configs/afp_configs',
    addSingleRequest: '/request_feedback_for_shop_id',
    getShopId: '/rateus/api/get_shops_by_brand_id',
    validateUserAndCreateRequest: '/requests/create',
    organisationManagerList: '/managers/list_new_v3',
    organisationLevelLists: '/hierarchies/levels',
    organisationManagerUpdate: '/managers/update',
    organisationManagerListUpdate: '/managers/managers_list_upload',
    dyanamicHierarchyList: '/hierarchies/dynamic_hierarchy_values',
    registerManagerProfile: '/managers/register_manager_profile_v2',
    sendVerificationMail: '/admin/resend_verification_email',
    organisationSearchManager: '/managers/managers_search_es',
    categoryRuleBasedOnType: '/actions/issue_filters' ,
    managersList: '/managers/list',
    staticAccordions: '/brands/static_accordions',
    uiRules: '/brands/ui_rules',
    createJobRequest:'/jobs/create',
    bulkUpdate: '/managers/bulk_update'


  },
  actionV1: {
    protocol: 'https',
    port: '443',
    apiPrefix: '/v1/litmus_actions',
    actionStatsComparisonData: '/comparison',
    ActionStatsTrendSummary: '/trends_data_rating_summary',
    HuddleSpotLight: '/huddle/huddle_summary_spotlights',
    meetingsList: '/meetings/list',
    Initiate_Huddle_Download: '/download/initiate_huddle_download',
    huddleCreate: '/meetings/create',
    huddleManagersList: '/managers/list',
    managersListbyLevelandRole: '/managers/list_by_level_and_role',
    escalationsCreate: '/huddle/escalations_create'
  },
  analyticsV1: {
    protocol: 'https',
    port: '443',
    apiPrefix: '/v1/litmus_analytics',
    comparisonData: '/comparison',
    trendDataRatingSummary: '/trends_data_rating_summary',
    AccountScoresSummary: '/score/summary_by_account',
    create_dashboard_reporting_job: '/create_dashboard_reporting_job',
    getDashboardReport: '/get_dashboard_reporting_jobs',
    EngagementSummaryByAccount: '/engagement/summary_by_account',
    getFilterList: '/filters/filter_list',
    saveFilter: '/filters/save_filter',
    removeFilter: '/filters/remove_saved_fitler',
    postLeaderboardSummary: '/score/leaderboard_summary',
    comparisonV2Data: '/comparison_v2',
    wordcloud: '/score/word_cloud',
    overallText: '/score/account',
    trendSummary: '/score/trends_summary',
    accountCrossTab: '/score/account_cross_tab',
    overallRating: '/overall_ratings_summary',
    crossTabAnalytics: '/cross_tab_analytics',
    scoreAccount: '/score/account',
    journeyConfig: '/relationship/journey_config',
    relationshipOverallSummary: '/relationship/overall_summary',
    relationshipTrendSummary: '/relationship/trend_summary',
    relationshipJourneySummary: '/relationship/journey_summary',
    relationshipDetailedSummary: '/relationship/detailed_summary',
    customerFeedList: '/relationship/customer_feed_list',
    relationshipCustomerList: '/relationship/customer_list',
    journeyConfigList:'/relationship/journey_config_list',
    removeJourneyConfig:'/relationship/remove_journey_config'
  },
  webPrivateCs: {
    protocol: 'https',
    port: '443',
    apiPrefix: '/cs/api/api',
    datasetValuesList: '/datasetvalues/list',
    getDatasetValue: '/datasets/list',
    uploadDatasetValue:'/datasetvalues/upload'
  },
  billing: {
    apiBaseUrl: 'https://staging.litmusworld.com/notifications',
    protocol: 'https',
    host: 'staging.litmusworld.com',
    port: '443',
    apiPrefix: '/api/v1/billing',
    usagePath: '/usage',
    settingsPath: '/settings',
    projectsPath: '/projects',
  },
  project_tabs: {
    "scores": {
      "enabled": true,
      "sub_modules": {
        "leaderboard": {
          "enabled": true
        },
        "summary": {
          "enabled": true
        },
        "interaction": {
          "enabled": true
        },
        "comparison": {
          "enabled": true
        },
        "verbatim": {
          "enabled": true
        },
        "custom": {
          "enabled": true
        }
      }
    },
    "inbox": {
      "enabled": true,
      "sub_modules": {
        "received": {
          "enabled": true
        },
        "chat": {
          "enabled": true
        },
        "history": {
          "enabled": true
        },
        "profile": {
          "enabled": true
        },
        "siblings": {
          "enabled": true
        },
        "text_category": {
          "enabled": true
        },
        "advanced_download": {
          "enabled": true
        },
        "sent_beta": {
          "enabled": true
        }
      }
    },
    "sentiment_analysis": {
      "enabled": true,
      "sub_modules": {
        "overview": {
          "enabled": true
        },
        "details": {
          "enabled": true
        },
        "summary": {
          "enabled": true
        },
        "feed_link_redirect": {
          "enabled": true
        },
        "cohort_footer": {
          "enabled": true
        }
      }
    },
    "engagement": {
      "enabled": true,
      "sub_modules": {
        "summary": {
          "enabled": true
        },
        "summary_v2": {
          "enabled": true
        },
        "comparison_v2": {
          "enabled": true
        },
        "page_view_v2": {
          "enabled": true
        }
      }
    },
    "action_summary_v2": {
      "enabled": true,
      "sub_modules": {
        "count": {
          "enabled": true
        },
        "ageing": {
          "enabled": true
        },
        "tat": {
          "enabled": true
        }
      }
    },
    "huddle": {
      "enabled": true,
      "sub_modules": {
        "all_meetings": {
          "enabled": true
        },
        "all_employee_spotlights": {
          "enabled": true
        },
        "all_action_plan": {
          "enabled": true
        },
        "all_process_improvements": {
          "enabled": true
        }
      }
    },
    "quick_sight": {
      "enabled": true
    },
    "settings": {
      "enabled": true,
      "sub_modules": {
        "general": {
          "enabled": true
        },
        "interaction": {
          "enabled": true
        },
        "channels": {
          "enabled": false
        },
        "organisation": {
          "enabled": true
        },
        "action": {
          "enabled": true
        },
        "datasets": {
          "enabled": true
        },
        "tools": {
          "enabled": true
        }
      }
    },
    "offers": {
      "enabled": true,
      "sub_modules": {
        "invitations": {
          "enabled": true
        },
        "offer_statistics": {
          "enabled": true
        },
        "campaign_statistics": {
          "enabled": true
        },
        "user_statistics": {
          "enabled": true
        }
      }
    },
    "reports": {
      "enabled": true,
      "sub_modules": {
        "response": {
          "enabled": true
        },
        "request": {
          "enabled": true
        }
      }
    }
  },
  account_tabs: {
    "scores": {
      "enabled": true,
      "sub_modules": {
        "summary_v2": {
          "enabled": true
        },
        "comparison": {
          "enabled": true
        },
        "overview": {
          "enabled": true
        },
        "verbatim": {
          "enabled": true
        }
      }
    },
    "inbox": {
      "enabled": true,
      "sub_modules": {
        "received": {
          "enabled": true
        },
        "chat": {
          "enabled": true
        },
        "history": {
          "enabled": true
        },
        "profile": {
          "enabled": true
        },
        "siblings": {
          "enabled": true
        }
      }
    },
    "engagement": {
      "enabled": true,
      "sub_modules": {
        "summary": {
          "enabled": true
        },
        "summary_v2": {
          "enabled": true
        },
        "comparison_v2": {
          "enabled": true
        },
        "page_view_v2": {
          "enabled": true
        }
      }
    }
  },
  tab_mappings: {
    account: {
      scores: ["overview","summary_v2", "comparison"],
      inbox: ['received', 'verbatim'],
      engagement: ['summary', 'summary_v2', 'comparison_v2']
    },
    project: {
      scores: [ 'summary', 'interaction','leaderboard', 'comparison', 'custom'],
      inbox: ['received', 'verbatim', 'wordcloud', "chat", "history", "profile", "siblings", "promotions"],
      engagement: ['summary', 'summary_v2', 'comparison_v2', 'page_view_v2'],
      action_summary_v2: ['count', 'ageing', 'tat'],
      huddle: ['all_meetings', 'all_employee_spotlights', 'all_action_plan', 'all_process_improvements'],
      /** Sentiment Analysis: main tabs + `feed_link_redirect` / `cohort_footer` for Customer Feedback UI. */
      sentiment_analysis: ['overview', 'details', 'summary', 'feed_link_redirect', 'cohort_footer']
    }
  }
};
